import { Button, DifficultyBadge, equal } from '@opositandopn/ui';
import { useFormikContext } from 'formik';

import { StepperBody } from '../../../../../components/shared/admin/layout/StepperBody';
import { StepperFooter } from '../../../../../components/shared/admin/layout/StepperFooter';
import { BaseComponentProps } from '../../../../../types/base-component.types';
import { TrainingPlanFormValues } from '../TrainingPlanEditor';

import styles from './TrainingPlanReviewStep.module.scss';

type ContainerProps = BaseComponentProps & {
  onCancel: () => void;
};

function TrainingPlanReviewStep({ onCancel }: ContainerProps) {
  const { initialValues, values, isSubmitting, handleSubmit } =
    useFormikContext<TrainingPlanFormValues>();

  return (
    <>
      <StepperBody className={styles['body']}>
        <div className={styles['preview']}>
          <div className={styles['preview__header']}>
            <h2 className={styles['title']}>{values.name}</h2>
            <DifficultyBadge difficulty={values.difficultyLevel} />
          </div>
          <div
            className={styles['description']}
            dangerouslySetInnerHTML={{ __html: values.description }}
          />
        </div>
      </StepperBody>
      <StepperFooter className={styles['footer']}>
        <div className={styles['footer__right']}>
          <Button
            type="button"
            variant="outline-danger"
            disabled={isSubmitting}
            onClick={onCancel}
          >
            Cancelar
          </Button>

          {!values.id && (
            <Button
              type="button"
              variant="primary"
              loading={isSubmitting}
              disabled={isSubmitting}
              onClick={() => {
                handleSubmit();
              }}
            >
              Publicar
            </Button>
          )}

          {values.id && (
            <Button
              type="submit"
              variant="primary"
              loading={isSubmitting}
              disabled={equal(values, initialValues) || isSubmitting}
            >
              Publicar cambios
            </Button>
          )}
        </div>
      </StepperFooter>
    </>
  );
}

export { TrainingPlanReviewStep };
